export default "__VITE_ASSET__XQOoZkn4__"